import { useToastStore } from '@/lib/stores/toastStore';

export function Toaster() {
  const { message, visible } = useToastStore();
  return (
    <div
      className={`toast${visible ? ' show' : ''}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {message}
    </div>
  );
}
